



































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  LinkedAccountApi,
  bankAccountUseDisplayMap,
  linkedBankAccountUseStatusDisplayMap,
  accountVerificationStatusDisplayMap,
  LinkedBankAccountUseStatus,
  LinkedBankAccountUse,
  AccountVerificationStatus
} from "@/shared/types";
import _ from "lodash";
import {
  linkedBankAccountUseStatusIconMap,
  accountVerificationStatusIconMap,
  linkedBankAccountUseStatusColorMap,
  linkedBankAccountUseStatusTitleMap
} from "@/shared/awesomeIconMapper";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useThemeStore } from "@/shared/store/theme";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { Validator } from "vee-validate";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useHsabEnrollmentStore } from "@/employee/store/hsabEnrollment";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";
import moment from "moment";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class HsabLinkedAccountsList extends Vue {
  isEditing = false;
  isResyncInProgress = false;
  isUpdatingReimbursementMethod = false;
  showConfirmModal = false;
  refreshButtonOverride = false;
  bankAccountToDelete: LinkedAccountApi = null;

  @Prop()
  isRedirectedToWex: boolean;

  @Prop()
  disabled: boolean;

  @Prop()
  isNotionalOnly: boolean;

  bankAccountStore = useBankAccountStore();
  themeStore = useThemeStore();
  custodianSettingStore = useCustodianSettingsStore();
  hsabEnrollmentStore = useHsabEnrollmentStore();
  featureFlagStore = useFeatureFlagStore();
  bankAccountUseDisplayMap = bankAccountUseDisplayMap;
  LinkedBankAccountUse = LinkedBankAccountUse;
  linkedBankAccountUseStatusIconMap = linkedBankAccountUseStatusIconMap;
  accountVerificationStatusIconMap = accountVerificationStatusIconMap;
  linkedBankAccountUseStatusColorMap = linkedBankAccountUseStatusColorMap;
  linkedBankAccountUseStatusDisplayMap = linkedBankAccountUseStatusDisplayMap;
  linkedBankAccountUseStatusTitleMap = linkedBankAccountUseStatusTitleMap;
  accountVerificationStatusDisplayMap = accountVerificationStatusDisplayMap;
  LinkedBankAccountUseStatus = LinkedBankAccountUseStatus;

  listFields = [
    {
      key: "bankAccountName",
      thClass: "text-left",
      tdClass: "",
      label: "Account Name",
      visible: true
    },
    {
      key: "bankAccountRouting",
      thClass: "text-left pl-1",
      tdClass: "pl-1",
      label: "Routing Number",
      visible: true
    },
    {
      key: "bankAccountNumber",
      thClass: "text-left pl-1",
      tdClass: "pl-1",
      label: "Account Number",
      visible: true
    },
    {
      key: "uses",
      label: "Use",
      thClass: "text-left",
      tdClass: "text-left",
      visible: true
    },
    {
      key: "delete",
      label: "",
      thClass: "",
      tdClass: "text-right",
      visible: this.canUnlinkAccounts
    }
  ];

  mounted () {
    this.hsabEnrollmentStore.loadPlanYearEnrollmentDetails();
  }

  get buttonsAreDisabled () {
    return this.isEditing || this.disabled;
  }
  get allAccounts (): any[] {
    if (!this.bankAccountStore.linkedAccounts) {
      return [];
    }
    return this.bankAccountStore.linkedAccounts.sort((a, b) => a.linkedBankAccountType.localeCompare(b.linkedBankAccountType))
        .map(item => ({...item, isEdit: false, isMissingUse: item.use.accountUse === LinkedBankAccountUse.Unspecified, name: item.bankAccountName}));
  }
  get visibleFields () {
    return this.listFields.filter(field => field.visible);
  }

  get hasActiveDirectDepositAccount () {
    return this.bankAccountStore.hasDirectDeposit;
  }

  get showNonDirectDepositConfigurationError () {
    return this.hsabEnrollmentStore.isPlanYearEnrollmentDataLoaded
        && this.hasActiveDirectDepositAccount
        && this.hsabEnrollmentStore.userHasNonDirectDepositReimbursementMethod;
  }

  get showRefreshButton (): boolean {
    return this.isRedirectedToWex || this.refreshButtonOverride;
  }
  onManualRefresh () {
    this.refreshButtonOverride = false;
    this.reloadLinkedBankAccounts();
    this.reloadPlanYearEnrollments();
  }
  onRefresh () {
    this.$parent.$emit("deep-link-click");
    this.reloadLinkedBankAccounts();
    this.reloadPlanYearEnrollments();
  }
  reloadLinkedBankAccounts () {
    this.isResyncInProgress = true;
    this.bankAccountStore.reSyncLinkedBankAccounts()
      .finally(() => this.isResyncInProgress = false);
  }

  reloadPlanYearEnrollments () {
    this.hsabEnrollmentStore.loadPlanYearEnrollmentDetails(true);
  }
  getEditButtonText (data) {
    const item = this.allAccounts[data.index];
    if (item.verificationStatus === AccountVerificationStatus.ConfirmationRequired) {
      return "ACTIVATE";
    }
    if (item.isMissingUse) {
      return "ACTIVATE";
    }
    if (this.showDirectDepositInfo) {
      return "set as direct deposit";
    }
    return "EDIT";
  }

  get isAnyAccountInConfirmationRequiredState (): boolean {
    return this.allAccounts.some(item => item.verificationStatus === AccountVerificationStatus.ConfirmationRequired);
  }

  get AreAllAccountInConfirmationRequiredState (): boolean {
    return !this.allAccounts.some(item => item.verificationStatus !== AccountVerificationStatus.ConfirmationRequired);
  }

  saveRowHandler (data) {
    const bankAccountName = this.allAccounts[data.index].bankAccountName;
    const name = this.allAccounts[data.index].name;
    if (!name) {
      this.allAccounts[data.index].name = bankAccountName;
      return;
    }
    this.bankAccountStore.setAccountName({
      name,
      linkedBankAccountId: this.allAccounts[data.index].linkedBankAccountId
    });
    if ( this.showDirectDepositInfo && data.item.use && data.item.use.accountUse !== LinkedBankAccountUse.DirectDeposit) {
      // no DD, force to DD
      data.item.use.accountUse = LinkedBankAccountUse.DirectDeposit;
    }
    this.bankAccountStore.putLinkedAccount(data.item);
    this.allAccounts[data.index].isEdit = !this.allAccounts[data.index].isEdit;
  }
  cancelRowHandler (data) {
    this.isEditing = false;
    this.allAccounts[data.index].name = this.allAccounts[data.index].bankAccountName;
    this.allAccounts[data.index].isEdit = !this.allAccounts[data.index].isEdit;
  }
  deleteRowHandler (data) {
    this.bankAccountToDelete = data.item;
    this.showConfirmModal = true;
  }
  onModalClose () {
    this.disableAll();
    this.bankAccountToDelete = null;
    this.showConfirmModal = false;
  }
  confirmDelete () {
    if (this.bankAccountToDelete) {
      this.bankAccountStore.deleteLinkedAccount(this.bankAccountToDelete);
    }
    this.bankAccountToDelete = null;
    this.showConfirmModal = false;
  }
  onRowClicked (data: any, index: number): void {
    if (!this.canUnlinkAccounts) {
      return;
    }
    this.isEditing = true;
    this.disableAll();
    this.allAccounts[index].isEdit = !this.allAccounts[index].isEdit;
  }

  getHumanReadableErrorMessage (message): string[] {
    const errorDescriptions = [];

    if (isNullEmptyOrUndefined(message)) {
      return errorDescriptions;
    }

    const base = message.replace("HSA Api Messages: ", "");
    const errors = base.split("BankingRepository - ");

    errors.forEach(error => {
      if (error.length > 0 && error.includes("Description: ")) {
        const errorSplits = error.split("Description: ");
        errorDescriptions.push(errorSplits[1]);
      }
    });

    return errorDescriptions;
  }

  onSetPaymentMethodToDirectDepositClicked () {
    this.isUpdatingReimbursementMethod = true;
    this.hsabEnrollmentStore.updateNonDirectDepositEnrollmentsToDirectDeposit().then(_ => {
      this.reloadLinkedBankAccounts();
      this.reloadPlanYearEnrollments();
    }).finally(() => this.isUpdatingReimbursementMethod = false);
  }
  get canUnlinkAccounts (): boolean {
    return this.featureFlagStore.flags.bend20386UnlinkBankAccountsEnabled;
  }
  disableAll () {
    this.allAccounts.forEach(item => {
        item.isEdit = false;
    });
  }
  @Watch("isRedirectedToWex")
  handleRedirectToWex () {
    if (this.isRedirectedToWex) {
      this.refreshButtonOverride = true;
      window.addEventListener("focus", this.handleFocus);
    }
  }
  handleFocus () {
    window.removeEventListener("focus", this.handleFocus);
    this.onRefresh();
  }
  get hasMissingUses (): boolean {
    return this.bankAccountStore.hasMissingUses;
  }
  get hasActiveOtherAccount (): boolean {
    return this.allAccounts.some(x => x.use.accountUse === LinkedBankAccountUse.Other && x.use.status === "active");
  }
  get showDirectDepositInfo (): boolean {
    return !this.hasActiveDirectDepositAccount && this.hasActiveOtherAccount;
  }
  get isNotionalOnlyAndHasDirectDepositAccount (): boolean {
    return this.isNotionalOnly && this.hasActiveDirectDepositAccount;
  }
  get isConsumerLinkedAccountsInErrorState (): boolean {
    return this.bankAccountStore.isConsumerLinkedAccountsInErrorState;
  }
  get showMissingUsesAlert (): boolean {
    if (this.AreAllAccountInConfirmationRequiredState) {
      return false;
    }

    return this.hasMissingUses && !this.isNotionalOnlyAndHasDirectDepositAccount;
  }

  getFormattedDate (date?: string): string {
    if (isNullEmptyOrUndefined(date)) {
      return "";
    }
    const local = moment.utc(date).local();
    if (isNullEmptyOrUndefined(local.zoneAbbr())) {
      return `${local.format("MM/DD/YYYY hh:mma")} ${local.tz(moment.tz.guess()).zoneAbbr()}`;
    }
    return local.format("MM/DD/YYYY hh:mma z");
  }
}
